import { Route } from '@angular/router';
import { AuthGuard } from '../../../shared/services';
import { InvoiceListComponent } from './invoice-list.component';

export const InvoiceListRoutes: Route[] = [
  {
    path: 'list/:type',
    component: InvoiceListComponent,
    canActivate: [AuthGuard],
    resolve: {}
  }
];
